<div class="input-group">
	<input [placeholder]="placeholder" class="form-control" [(ngModel)]="term" />
</div>
